<template>
  <section v-if="mainNews" class="bg-white py-5">
    <div class="container">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl md:text-2xl text-[#222] m-0 font-bold">
          Жаңалықтар
        </h2>
        <router-link
          :to="{ name: 'category_view', params: { slug: 'news' } }"
          class="flex items-center gap-1 text-[#222] no-underline text-sm"
        >
          Жаңалықтарға өту
          <svg-icon name="arrow-right" class="w-7 h-7 fill-none" />
        </router-link>
      </div>

      <div
        class="border border-solid border-[#DEDEDE] rounded-[24px] flex flex-col md:flex-row"
      >
        <!-- Главная новость -->
        <div
          class="w-full md:w-1/2 p-5 md:border-r border-solid border-[#DEDEDE]"
        >
          <div
            class="w-full h-[200px] sm:h-[314px] rounded-xl overflow-hidden bg-[#e9f0f4] mb-4"
          >
            <img
              :src="mainNews.image"
              alt="Новость"
              class="w-full h-full object-cover"
            />
          </div>
          <div
            class="inline-flex items-center gap-1 bg-[#e1f3ea] px-2 py-1 rounded-lg text-[#5e6060] text-sm mb-4"
          >
            <!-- <span class="text-[#36494a]">✓</span> -->
            <span>{{ mainNews.created_at }}</span>
          </div>
          <h3
            class="text-base font-semibold md:text-lg text-[#222] m-0 mb-4 leading-5"
          >
            {{ mainNews.title }}
          </h3>
          <p
            class="text-[#444] m-0 mb-7 leading-normal text-sm md:text-base"
            v-html="
              mainNews.description
                ? mainNews.description.substring(0, 200) +
                  (mainNews.description.length > 200 ? '...' : '')
                : ''
            "
          ></p>
          <router-link
            v-if="mainNews && mainNews.id"
            :to="{
              name: 'article_view',
              params: { id: mainNews.id },
            }"
            class="md:w-auto bg-[#fdc902] text-[#222] border-none px-6 py-3 rounded-2xl text-base cursor-pointer"
          >
            Толығырақ
          </router-link>
        </div>

        <!-- Список новостей -->
        <div class="w-full md:w-1/2 flex flex-col">
          <div
            v-for="item in news"
            :key="item.id"
            class="p-5 border-b border-[#dedede] last:border-b-0"
          >
            <div
              class="inline-flex items-center gap-1 bg-[#e1f3ea] px-2 py-1 rounded-full text-[#5e6060] text-sm mb-2 md:mb-4"
            >
              <span>{{ item.created_at }}</span>
            </div>
            <router-link
              :to="{
                name: 'article_view',
                params: { id: item.id },
              }"
              class="block font-semibold text-base md:text-lg text-[#222] m-0 leading-5"
            >
              {{
                item.title === item.title.toUpperCase()
                  ? item.title.charAt(0).toUpperCase() +
                    item.title.slice(1).toLowerCase()
                  : item.title
              }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import { newsService } from "@/services";
import { formatDate } from "@/utils/date";

export default {
  name: "NewsSection",
  components: {
    SvgIcon,
  },
  data() {
    return {
      mainNews: {},
      news: [],
    };
  },
  methods: {
    async getNews() {
      const response = await newsService.getNewsList({ limit: 6 });
      response.results = response.results.map((item) => ({
        ...item,
        created_at: formatDate(item.created_at),
      }));

      this.mainNews = response.results[0];
      // const article = await articleService.getArticle(this.mainNews.id);
      // this.mainNews.content = article.text;
      this.news = response.results.slice(1);
    },
  },
  created() {
    this.getNews();
  },
};
</script>

<style scoped lang="scss">
/* Все стили теперь в Tailwind классах */
</style>
